import { useState } from "react"

import { Button } from "./Button"
import { Command, CommandEmpty, CommandInput, CommandItem, CommandList } from "./Command"
import { FiltroAplicado } from "./FiltroAplicado"
import * as Icones from "./Icones"
import { Popover, PopoverContent, PopoverTrigger } from "./Popover"
import { cn } from "../lib/cn"

export type OpcaoDoFiltro = { valor: string; rotulo: string; contagem?: number }

export function FiltroComBusca({
  rotulo,
  placeholder,
  opcoes,
  valor,
  aoEscolher,
  classe,
}: {
  rotulo: string
  placeholder: string
  opcoes: OpcaoDoFiltro[]
  valor: string | null
  aoEscolher: (valor: string | null) => void
  classe?: string
}) {
  const [aberto, definirAberto] = useState(false)
  const escolhida = opcoes.find((opcao) => opcao.valor === valor) ?? null

  return (
    <div data-slot="filtro-com-busca" className={cn("flex min-w-0 flex-wrap items-center gap-2", classe)}>
      <Popover open={aberto} onOpenChange={definirAberto}>
        <PopoverTrigger asChild>
          <Button type="button" variant="outline" size="sm" className="h-7 text-xs">
            <Icones.Filtrar />
            Filtrar
          </Button>
        </PopoverTrigger>
        <PopoverContent align="start" className="w-64 p-0">
          <Command>
            <CommandInput placeholder={placeholder} className="h-8" />
            <CommandList>
              <CommandEmpty>Nada encontrado.</CommandEmpty>
              {opcoes.map((opcao) => {
                const marcada = opcao.valor === valor
                return (
                  <CommandItem
                    key={opcao.valor}
                    value={opcao.rotulo}
                    data-marcada={marcada ? "sim" : "nao"}
                    className={cn("cursor-pointer", marcada && "font-semibold")}
                    onSelect={() => {
                      definirAberto(false)
                      aoEscolher(marcada ? null : opcao.valor)
                    }}
                  >
                    <span className={cn("flex size-4 flex-none items-center justify-center", !marcada && "invisible")} aria-hidden="true">
                      <Icones.Marcado />
                    </span>
                    <span className="min-w-0 flex-1 truncate">{opcao.rotulo}</span>
                    {opcao.contagem !== undefined && (
                      <span className="flex-none text-(length:--texto-xs) text-(--tinta-3) tabular-nums">{opcao.contagem}</span>
                    )}
                  </CommandItem>
                )
              })}
            </CommandList>
          </Command>
        </PopoverContent>
      </Popover>
      {escolhida !== null && (
        <FiltroAplicado rotulo={rotulo} valor={escolhida.rotulo} aoLimpar={() => aoEscolher(null)} compacto />
      )}
    </div>
  )
}
